import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreateNutritionalCounsellingMutation as useChCreateNutritionalCounsellingMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChCreateNutritionalCounsellingMutation.graphql"

const mutation = graphql`
  mutation useChCreateNutritionalCounsellingMutation($input: Ch_createNutritionalPrescriptionInput!) {
    ch_createNutritionalPrescription(input: $input) {
      ch_NutritionalPrescription {
        id
        ...chNutritionalCounsellingFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateNutritionalCounsellingMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreateNutritionalCounsellingMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateNutritionalCounsellingMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateNutritionalCounsellingMutation }
